import React from 'react';
import { styled } from '@mui/system';
import store from '../../redux/store.js';
import { Text, Theme, Services, localizationMaps } from '@simplybenefits/sb-ui-library';
import brandIconImage from '../../assets/icon-color.png';
import fullColorLogoImage from '../../assets/logo-full-color-medium.png';

const CardStyled = styled('div')(({ theme }) => ({
    height: 300, 
    width: 500, 
    borderRadius: 6, 
    margin: 30, 
    backgroundImage: `url(${ `https://d6hvupc5g7lnm.cloudfront.net/images/mycard-background.png` })`, 
    backgroundSize: 'cover', 
    boxShadow: '0px 12px 40px rgba(0, 0, 0, 0.15)', 
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    [theme.breakpoints.down('600')]: {
        height: 'auto',
        minHeight: 300
    }
}));

const CardContentLeft = styled('div')(({ theme }) => ({
    width: '60%',
    paddingRight: 25,
    borderRight: `1pt solid #EEEEEE`,
    [theme.breakpoints.down('530')]: {
        marginRight: 10
    }
}));

const CardContentLeftNoBorder = styled('div')(({ theme }) => ({
    width: '60%',
    paddingRight: 25,
    [theme.breakpoints.down('530')]: {
        marginRight: 10
    }
}));

const CardFixed = styled('div')(({ theme }) => ({
    marginTop: 10,
    paddingLeft: 53,
    paddingRight: 53,
    [theme.breakpoints.down('600')]: {
        display: 'none'
    }
}));

const CardFooter = styled('div')(({ theme }) => ({
    borderBottomLeftRadius: 6,
    borderBottomRightRadius: 6,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 9,
    paddingBottom: 10,
    backgroundColor: theme.palette.primary.main
}));

/**
 * If the carrier is La Capitale or Empire, display custom carrier names
 * @param {*} carrier 
 * @returns 
 */
const getOocCarrier = (carrier) => {
    if (carrier === "La Capitale") {
        return "Beneva";
    } 

    if (carrier === "Empire") { 
        return "Empire/Trident";
    }

    return localizationMaps.fromEnglish('carriers', carrier);
};

/**
 * 
 * @returns 
 */
const English = ({ whitelabel, user, className, coverage, company, divisionName, oocPolicyNo, carrier, name, _navigateTo }) => {
    const styles = {
        cards: {
            display: 'flex',
            maxWidth: '100%',
            flexWrap: 'wrap',
            justifyContent: 'center'
        },
        logo: {
            height: 40
        },
        icon: {
            height: 30
        },
        cardInner: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'flex-start'
        },
        cardTitle: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingLeft: 40,
            paddingRight: 40,
            marginTop: 20
        },
        cardContent: {
            display: 'flex',
            flexDirection: 'row',
            paddingRight: 40,
            paddingLeft: 40
        },
        cardContentRight: {
            width: '50%',
            paddingLeft: 35
        },
        cardContentFull: {
            width: '100%'
        },
        cardMobileDetails: {
            display: 'flex',
            flexDirection: 'column',
            marginLeft: 20,
            marginRight: 20
        },
        cardMobileRow: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'baseline'
        },
        cardDetailsLower: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignContent: 'center',
            paddingLeft: 40,
            paddingRight: 40
        },
        centerBlock: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: "center",
            whiteSpace: "nowrap"
        },
        wrapBlock: {
            display: 'flex',
            flexWrap: "nowrap",
            wordBreak: 'break-all',
            marginRight: 10
        },
        cardFooter: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: 10,
            backgroundColor: store.getState().whitelabel.primaryColor || Theme.colors.skyBlue,
            width: '100%'
        },
        downloadBtnContainer: {
            display: 'flex',
            flex: 1,
            justifyContent: 'flex-end',
            marginBottom: 10
        },
        benefit: {
            width: "27%",
            marginRight: 10
        },
        carrier: {
            width: "31%"
        },
        policyNo: {
            width: "22%"
        },
        certNo: {
            width: "18%",
            display: "flex",
            justifyContent: "flex-end"
        },
        dataRow: {
            display: 'flex',
            flexDirection: "row",
            justifyContent: 'space-between',
            alignItems: "center", 
            paddingTop: 10,
            paddingBottom: 10,
            borderBottom: `1pt solid #EEEEEE`
        }
    };

    const carrierWording = carrier.toLowerCase() === 'orion' 
        ? "Appels à frais virés"
        : "Internationalement";

    return (
        <>
            <CardStyled>
                <div style={ styles.cardTitle }>
                    <Text
                        color={ whitelabel.secondaryColor || Theme.colors.mediumDarkGrey }
                        extraLarge
                        bold
                        margin="0"
                    >
                        <span style={{ fontWeight: 900 }}>Ma</span>
                        <span style={{ color: whitelabel.primaryColor || Theme.colors.skyBlue, fontFamily: 'AvenirLTPro-Book' }}>Carte</span>
                    </Text>

                    {/* Icon should be 150 x 150 px */}
                    <img
                        alt="Brand Icon"
                        src={ whitelabel.logoSmall || brandIconImage }
                        style={ styles.icon }
                    />
                </div>

                <CardFixed>
                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' } }>

                        <div style={{ display: "flex", flexDirection: "row" }}>
                            <Text small light customStyle={ styles.benefit }>
                                {""}
                            </Text>

                            <Text tiny light customStyle={ styles.carrier }>
                                                N° d'assureur
                            </Text>

                            <Text tiny light customStyle={ styles.policyNo }>
                                                N° de Contrat
                            </Text>

                            <Text tiny light customStyle={ styles.certNo }>
                                                N° de Cert
                            </Text>
                        </div>

                        <div style={ styles.dataRow }>
                            <Text small bold customStyle={ styles.benefit }>
                                                Médicaments
                            </Text>

                            <Text small bold customStyle={ styles.carrier }>
                                                34
                            </Text>

                            <Text small bold customStyle={ styles.policyNo }>
                                { user.groupNum }
                            </Text>

                            <Text small bold customStyle={ styles.certNo }>
                                { user.cert }
                            </Text>
                        </div>

                        <div style={ styles.dataRow }>
                            <Text small bold customStyle={ styles.benefit }>
                                                Soins de Santé
                            </Text>

                            <Text small bold customStyle={ styles.carrier }>
                                                Simply Benefits
                            </Text>

                            <Text small bold customStyle={ styles.policyNo }>
                                { user.groupNum }
                            </Text>

                            <Text small bold customStyle={ styles.certNo }>
                                { user.cert }
                            </Text>
                        </div>

                        {
                            coverage.dental.benefitActive ?
                                <div style={ { ...styles.dataRow, border: "none" } }>
                                    <Text small bold customStyle={ styles.benefit }>
                                                    Soins Dentaires
                                    </Text>

                                    <Text small bold customStyle={ styles.carrier }>
                                                    610361
                                    </Text>

                                    <Text small bold customStyle={ styles.policyNo }>
                                        { user.groupNum }
                                    </Text>

                                    <Text small bold customStyle={ styles.certNo }>
                                        { user.cert }
                                    </Text>
                                </div>
                                :
                                null
                        }

                    </div>

                </CardFixed>

                <div style={ styles.cardDetailsLower }>
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>

                        <div style={ { ...styles.centerBlock, marginRight: 30 } }>
                            <Text medium customStyle={{ marginRight: 5 }}>
                                Classe
                            </Text>
                            <Text small bold>
                                { className }
                            </Text>
                        </div>

                        <div style={ styles.centerBlock }>
                            <Text medium customStyle={{ marginRight: 5 }}>
                                            Division
                            </Text>
                            <Text small bold>
                                { divisionName }   
                            </Text>
                        </div>

                    </div>

                    <Text 
                        large 
                        customStyle={{ paddingBottom: 5 }} 
                        fontFamily="AvenirLTPro-Book"
                    >
                        assure
                    </Text>
                </div>

                <CardFooter>
                    <Text
                        color={Theme.colors.surface}
                        small
                        bold
                        margin="0 5px 0 0"
                        customStyle={{ wordBreak: "break-word" }}
                    >
                        {name}
                    </Text>

                    <Text
                        color={Theme.colors.surface}
                        small
                        bold
                        margin="0 5px 0 0"
                        customStyle={{ wordBreak: "break-word" }}
                    >
                        {company}
                    </Text>
                </CardFooter>
            </CardStyled>

            {/* For Mobile */}

            <CardStyled>
                <div style={ styles.cardTitle }>
                    {/* Brand Logo should be 852 x 180 px */}
                    {
                        whitelabel.logo ?
                            <img
                                alt="Brand Logo small"
                                src={ whitelabel.logo }
                                style={{
                                    height: 40
                                }}
                            />
                            :
                            <img
                                alt="Simply Benefits small"
                                src={ fullColorLogoImage }
                                style={{
                                    height: 40,
                                    marginLeft: -5
                                }}
                            />
                    }
                </div>


                <div style={ styles.cardContent }>

                    {
                        coverage.outOfCountry.benefitActive === 1 ?

                            <CardContentLeft>
                                <Text tiny bold customStyle={{ marginBottom: 5 }}>
                                        Assistance Voyage D'urgance
                                </Text>

                                <Text customStyle={{ fontSize: 9, marginBottom: 5 }}>
                                    <strong>Service médical 24/7 pendant le voyage.</strong> Veuillez appeler dans les 48 heures pour une facturation directe. 
                                </Text>

                                <div style={{ display: "flex", flexDirection: "row" }}>
                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", width: "56%" }}>
                                        <Text customStyle={{ fontSize: 11, height: "35px" }}>
                                                Au Canada ou aux États-Unis:
                                        </Text>

                                        <Text customStyle={{ fontSize: 11 }}>
                                            {carrierWording}:
                                        </Text>

                                        {
                                            oocPolicyNo !== null ?
                                                <Text customStyle={{ fontSize: 11, height: "30px", paddingTop: "5px", marginBottom: "8px" }}>
                                                        Numéro de police HDP:
                                                </Text>
                                                :
                                                null
                                        }

                                        <Text customStyle={{ fontSize: 11 }}>
                                                Fournisseurs HDP:
                                        </Text>
                                    </div>

                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }} >
                                        <Text bold customStyle={{ fontSize: 11, height: "35px", paddingTop: "7px" }}>
                                            { Services.constants.phoneNumbers[carrier].northAmerica }
                                        </Text>

                                        <Text bold customStyle={{ fontSize: 11 }}>
                                            { Services.constants.phoneNumbers[carrier].international }
                                        </Text>

                                        {
                                            oocPolicyNo !== null ?
                                                <Text bold customStyle={{ fontSize: 11, height: "30px", paddingTop: "12px", marginBottom: "5px" }}>
                                                    { oocPolicyNo }
                                                </Text>
                                                :
                                                null
                                        }

                                        <Text bold customStyle={{ fontSize: 11 }}>
                                            { getOocCarrier(coverage.outOfCountry.carrier) }
                                        </Text>
                                    </div>
                                </div>
                            </CardContentLeft>
                            :
                            <CardContentLeftNoBorder>
                                <Text tiny bold>
                                            Carte De Médicaments Sur Ordonnance
                                </Text>

                                <Text superTiny>
                                                Pour utlisation <strong> au Canada</strong> seulement. Services de centre d'appels pour pharmacie fournis par Assure.
                                </Text>

                                <Text bold customStyle={{ fontSize: 12, marginBottom: 5, marginTop: 5 }}>
                                    {Services.constants.phoneNumbers.Assure.number}
                                </Text>
                            </CardContentLeftNoBorder>
                    }

                                
                    {
                        coverage.outOfCountry.benefitActive === 1 ?

                            <div style={styles.cardContentRight}>
                                <Text tiny bold>
                                            Carte De Médicaments Sur Ordonnance
                                </Text>

                                <Text superTiny>
                                                Pour utlisation <strong> au Canada</strong> seulement. Services de centre d'appels pour pharmacie fournis par Assure.
                                </Text>

                                <Text bold customStyle={{ fontSize: 12, marginBottom: 5, marginTop: 5 }}>
                                    {Services.constants.phoneNumbers.Assure.number}
                                </Text>
                            </div>
                            :
                            null
                    }

                </div>
                <CardFooter>
                    <Text
                        color={Theme.colors.surface}
                        small
                        bold
                        margin="0 5px 0 0"
                    >
                        {Services.constants.phoneNumberCanadaUSA}
                    </Text>

                    <Text
                        color={Theme.colors.surface}
                        small
                        bold
                        margin="0 5px 0 0"
                        onClick={ _navigateTo }
                    >
                        {Services.constants.publicSiteUrl}
                    </Text>
                </CardFooter>
            </CardStyled>
        </>);
};

export default English;